export default "__VITE_ASSET__iut$FIER__"